import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/utils/tokens/sms';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType[] = [
  'TOKEN_CREDENTIALS', // post
  'TOKEN_AUTH_USER_OR_CREDENTIALS', // get
];
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/58af8b0d-5d58-4364-a068-f4cd793d7cac?version=36d18f23-3ed5-4b7c-adee-3889ccf888f2&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '2',
    bussinessErrorVariant: 'processFailure',
    message: 'Ocorreu um erro ao enviar SMS',
  },
  {
    code: '3',
    bussinessErrorVariant: 'tokenExpired',
    message: 'Token inválido ou expirado',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
